<div (click)="setValue($event)">
    <div>
        <mat-icon>star_border</mat-icon>
        <mat-icon>star_border</mat-icon>
        <mat-icon>star_border</mat-icon>
        <mat-icon>star_border</mat-icon>
        <mat-icon>star_border</mat-icon>
    </div>
    <div style="position: absolute;top: 0px; clip-path: polygon(0 0, 0% 0, 0% 100%, 0% 100%);" #stars>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
    </div>
</div>